import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData, Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const { convertToFloat } = Helpers

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode } = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const { setShowForm, setStepApplilication, setShowSection, setImagesCurrentIndex } = globalStates

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData

        const {
            FormRequestGlobal: { onResetForm: resetRequest },
            FormCollateral: { onResetForm: resetCollateral }
        } = Forms

        resetRequest()
        resetCollateral()

        setShowSection('HOME')
        setImagesCurrentIndex(0)

        executeFetchAllCreditsApplications()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication - 1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication + 1)
    }


    const handleClickCloseImage = () => {
        const { setShowSection, setImagesCurrentIndex } = globalStates
        const { FormCollateral: { onResetForm } } = Forms

        onResetForm()
        setShowSection('HOME')
        setImagesCurrentIndex(0)
    }

    const handleClickShowCollateralImages = async (idcollateral) => {
        const { FormCollateral: { setFormState } } = Forms
        const { setShowSection, setImagesCurrentIndex, setFormOpeningMode } = globalStates
        const { fetchCollateralImages: { executeFetchCollateralImages } } = FetchData

        // 🔒 Forzar solo lectura
        setFormOpeningMode('READONLY')

        // siempre arrancar desde la primera imagen
        setImagesCurrentIndex(0)

        // seteo del colateral actual
        setFormState(prev => ({
            ...prev,
            idcollateral,
            images: []
        }))

        // trae imágenes del backend
        executeFetchCollateralImages()

        // cambia a visor
        setShowSection('IMAGE')
    }

    const handleNextCollateralImage = () => {
        const { FormCollateral: { formState } } = Forms
        const images = formState.images || []
        const { setImagesCurrentIndex } = globalStates

        if (images.length <= 1) return

        setImagesCurrentIndex((prevIndex) =>
            prevIndex + 1 < images.length ? prevIndex + 1 : 0
        )
    }

    const handlePreviousCollateralImage = () => {
        const { FormCollateral: { formState } } = Forms
        const images = formState.images || []
        const { setImagesCurrentIndex } = globalStates

        if (images.length <= 1) return

        setImagesCurrentIndex((prevIndex) =>
            prevIndex - 1 >= 0 ? prevIndex - 1 : images.length - 1
        )
    }


    const handleClickCleanUpFiles = (event) => {
        const { FormRequestGlobal: { setFormState } } = Forms

        // const { fetchAllDeposits } = FetchData
        // const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        // executeFetchAllDeposits()

    }

    //     const handleClickDeleteDocument = (iddocumento) => {

    //         const { fetchAllFiles } = FetchData
    //         const { executeFetchAllFiles } = fetchAllFiles
    //         Swal.fire({
    //             title: '¿Desea eliminar este registro?',
    //             showConfirmButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: 'Eliminar',
    //             cancelButtonText: 'Cancelar'
    //         }).then(async result => {
    //             if (result.isConfirmed) {
    //                 await marvarApi.delete(`/leases/common/delete-document/${iddocumento}`)
    //                 .then( ({ data }) => {
    //                     alertMessage(data)
    //                     if (data.title === 'OK') {
    //                         executeFetchAllFiles()
    //                         // closeModal()
    //                         }else{

    //                         }
    //                 }).catch(error => {
    //                     console.log('API ERROR: ', error)
    //                 })
    //             }
    //         })
    //     }

    //     const handleClickDeleteDeposit = (iddocumento) => {

    //         const { fetchAllDeposits } = FetchData
    //         const { executeFetchAllDeposits } = fetchAllDeposits
    //         Swal.fire({
    //             title: '¿Desea eliminar este registro?',
    //             showConfirmButton: true,
    //             showCancelButton: true,
    //             confirmButtonText: 'Eliminar',
    //             cancelButtonText: 'Cancelar'
    //         }).then(async result => {
    //             if (result.isConfirmed) {
    //                 await marvarApi.delete(`/leases/management/delete-deposit/${iddocumento}`)
    //                 .then( ({ data }) => {
    //                     alertMessage(data)
    //                     if (data.title === 'OK') {
    //                         executeFetchAllDeposits()
    //                         // closeModal()
    //                         }else{

    //                         }
    //                 }).catch(error => {
    //                     console.log('API ERROR: ', error)
    //                 })
    //             }
    //         })
    //     }

    //     const handleChangeTotalMonths = ({ target }) => {
    //         // console.log(event);
    //         const { FormLeases } = Forms
    //         const { formState ,setFormState } = FormLeases

    //         // const data = JSON.parse(event.target.value || null)

    //         const { name, value } = target;
    //         setFormState({
    //             ...formState,
    //             [ name ]: value,
    //             contrato_total_alquiler: (formState.contrato_costo_alquiler * (value || 0))
    //         });
    //     }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;


        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (clean_deposito_monto / tipo_cambio)
            }))
        }
    }


    const onSubmitFormApplies = async (e) => {

        e.preventDefault()

        handleClickNextStep()

    }

    const onSendLogs = async (e) => {


        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { fetchInfoObservations: { executeFetchAllObservations } } = FetchData


        const { getCurrentDate } = Helpers

        await marvarApi.post(`/credits/common/log-vehicle/${formState.idcredito}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState((prevState) => ({
                        ...prevState,
                        aprobacion_observaciones: ''
                    }))
                    executeFetchAllObservations()
                }
            })

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()

        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { getCurrentDate } = Helpers


        const { fetchAllFiles: { executeFetchAllFiles }, fetchInfoApplication: { executeFetchInfoApplication } } = FetchData



        if (formState.acceptedFiles.length <= 0) {
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = new FormData();

        _data.append('idcredito', formState.idcredito);
        _data.append('department', 'JURIDICO');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if (formState.idcredito > 0) {

            await marvarApi.post(`/credits/common/create-document`, _data)
                .then(async ({ data }) => {
                    alertMessage(data)
                    setFormState(prevState => ({
                        ...prevState,
                        acceptedFiles: [],
                        fileRejections: []
                    }))
                    executeFetchAllFiles()
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleClickDeleteDocument = (iddocumento) => {

        const { fetchAllFiles } = FetchData
        const { executeFetchAllFiles } = fetchAllFiles
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/common/delete-document/${iddocumento}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllFiles()
                            // closeModal()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit, FormCollateral } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormCollateral = FormCollateral.onResetForm
        onResetForm()
        onResetFormCollateral()
        closeModal()
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData

        const { getCurrentDate } = Helpers


        if (formState.movimiento_tipo === 'EFECTIVO') {

            const _data = {
                idcredito: formStateGlobal.idcredito,
                deposito_usuario: user.username,
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: formState.clean_deposito_monto,
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: formState.deposito_tipo_cambio,
                deposito_quetzal: formState.clean_deposito_quetzales,
                deposito_dolares: formState.clean_deposito_dolares,
                idcaja: formState.idcaja,
                deposito_observaciones: formState.deposito_observaciones,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate()
            }

            await marvarApi.post(`/credits/common/create-deposit-cash`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchAllDeposits()
                        closeModal()
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }

        if (formState.movimiento_tipo === 'DEPOSITO') {

            if (formState.acceptedFiles.length <= 0) {

                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }

                alertMessage(messageCustom)

                return
            }

            const _data = new FormData();

            _data.append('idcredito', formStateGlobal.idcredito)
            _data.append('idbanco', formState.idbanco)
            _data.append('movimiento_tipo', formState.movimiento_tipo)
            _data.append('deposito_fecha', formState.deposito_fecha)
            _data.append('deposito_usuario', user.username)
            _data.append('deposito_monto', formState.clean_deposito_monto)
            _data.append('deposito_moneda', formState.deposito_moneda)
            _data.append('deposito_tipo_cambio', formState.deposito_tipo_cambio)
            _data.append('deposito_quetzal', formState.clean_deposito_quetzales)
            _data.append('deposito_dolares', formState.clean_deposito_dolares)
            _data.append('boleta_numero', formState.boleta_numero)
            _data.append('usuario_creo', user.username)
            _data.append('fecha_creo', getCurrentDate())

            formState.acceptedFiles.forEach((file, index) => {
                _data.append(`images`, file);
            });

            await marvarApi.post(`/credits/common/create-deposit-bank`, _data)
                .then(({ data }) => {
                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllDeposits()
                        onResetForm()
                        closeModal()

                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormDeposit
        const { deposito_tipo_cambio } = formState

        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value * tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value),
                deposito_dolares: numberFormatter.format(clean_value / tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value / tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        // const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto / tipo_cambio)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {

        const { FormDeposit: { onResetForm } } = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ iddeposit: iddeposit })
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickDownloadImage = async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    }

    const handleClickDeleteDeposit = (iddeposit) => {

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/common/delete-deposit/${iddeposit}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllDeposits()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const onSubmitFormCollateral = async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers

        //HOOKS
        const { FormCollateral: { formState }, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const { modalOpeningMode } = globalStates

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData

        //Validaciones generales
        if (formState.type_collateral === '') {
            const messageCustom = {
                message: 'Debe seleccionar un tipo de garantia',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        let _data = {
            idcredito: formStateGlobal.idcredito,
            title: formState.title,
            type_collateral: formState.type_collateral,
            estate: formState.estate,
            folio: formState.folio,
            department: formState.department,
            book: formState.book,
            description: formState.description,
            valor: formState.clean_valor,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            chasis: formState.chasis,
        }


        if (formState.idcollateral > 0) {

            if (modalOpeningMode === 'EDITABLE') {

                _data['usuario_modifico'] = user.username;
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put(`/credits/mgmt-managements/collateral/${formState.idcollateral}`, _data)
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            executeFetchCollateral()
                            handleClickCloseModal()
                        }

                    }).catch(error => { console.log('API ERROR: ', error) })
            } else {
                handleClickCloseModal()
            }

        } else {

            _data['usuario_creo'] = user.username;
            _data['fecha_creo'] = getCurrentDate();

            await marvarApi.post(`/credits/mgmt-managements/collateral`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchCollateral()
                        handleClickCloseModal()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        }

    }


    const handleClickFetchInfoCollateral = async (idcollateral, modeOpening) => {

        const { FormCollateral: { onResetForm, setFormState } } = Forms

        const { fetchInfoCollateral: { setParamsToSearch, executeFetchCollateral } } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idcollateral: idcollateral })
        executeFetchCollateral()

        setFormState(prevState => ({
            ...prevState,
            idcollateral: idcollateral
        }))


        handleClickShowModal('', 'Formulario de Garantias', 'collateral-section', {}, modeOpening)

    }

    const handleClickDeleteCollateral = (idcollateral) => {

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/mgmt-managements/delete-collateral/${idcollateral}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchCollateral()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickFetchInfoApplication = async (idcredito, idcotizacion, modeOpening) => {

        const { FormRequestGlobal: { onResetForm, setFormState } } = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito,
            idcotizacion: idcotizacion,
        }))
        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm(modeOpening)

    }

    const handleClickDeleteApplication = (idcredito) => {

        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            text: 'Esta acción eliminara toda la informacion relacionada con esta solicitud. Esta accion no se puede deshacer'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/credits/mgmt-managements/${idcredito}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllCreditsApplications()
                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickApproval = async () => {
        //HOOKS
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal
        const { getCurrentDate } = Helpers


        if (formState.aprobacion_check === 'Devuelto a Gestor') {
            await marvarApi.put(`/vehicle/legal/aprobacion-check/${formState.idcredito}`, { aprobacion_check: 'Devuelto a Juridico', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate() })
                .then(({ data }) => {
                    alertMessage(data)
                    handleClickHideForm()
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
        } else {
            handleClickHideForm()
        }
    }

    const handleClickUpdateState = () => {

        const { setShowForm, setStepApplilication } = globalStates
        const { getCurrentDate } = Helpers
        const { fetchAllCreditsApplication: { executeFetchAllCreditsApplications } } = FetchData
        const { FormRequestGlobal: { formState, onResetForm } } = Forms

        Swal.fire({
            title: '¿Desea enviar la solicitud al departamento de Administracion para su aprobacion?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/credits/legal-managements/aprobacion-check/${formState.idcredito}`, { aprobacion_check: 'Pendiente Aprobacion Contrato', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate() })
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === "OK") {
                            onResetForm()
                            executeFetchAllCreditsApplications()

                            setStepApplilication(0)
                            setShowForm(false)
                        }
                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }




    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        onSubmitFormApplies,
        onSendLogs,
        handleClickCleanUpFiles,
        handleClickReturnStep,
        handleClickNextStep,
        onSubmitFormFiles,
        handleClickDeleteDocument,
        handleClickShowModal,
        handleClickCloseModal,
        onSubmitFormDeposits,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        handleClickFetchInfoDeposit,
        handleClickDownloadImage,
        handleClickDeleteDeposit,
        onSubmitFormCollateral,
        handleClickFetchInfoCollateral,
        handleClickDeleteCollateral,
        handleClickFetchInfoApplication,
        handleClickDeleteApplication,
        handleClickApproval,
        handleClickShowCollateralImages,
        handleClickCloseImage,
        handleNextCollateralImage,
        handlePreviousCollateralImage,
        handleClickUpdateState
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
} 